import { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HostBackend } from '../HostBackend.js';
import { GetHeaders } from '../../Components/Admin/Functions/FetchHeaders.js';
import { FilterParkAndUnivers } from '../../Components/Public/Filters/FilterParkAndUnivers.js';
import { ArchivesAttractions } from '../../Pages/Public/ArchivesAttractions.js';
import { Archive } from '../../Pages/Public/Archive.js';
import { NotFound } from '../../Pages/Public/NotFound.js';

export const RouteArchives = () => {
    const backend = HostBackend();
    const guest = sessionStorage.getItem('guest');
    const [parks, setParks] = useState([]);
    const [arc, setArc] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
            const datasParks = await fetch(`${backend}/nav/parks`, GetHeaders(guest));
            const parks = await datasParks.json();
            setParks(parks);
            const dataArc = await fetch(`${backend}/nav/archives`, GetHeaders(guest));
            const arc = await dataArc.json();
            setArc(arc);
        };
        fetchData();
    }, [backend, guest]);
    if (parks.err) window.location.href = '/';
    const navParks = FilterParkAndUnivers(parks);
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/archives-des-attractions" element={<ArchivesAttractions navParks={navParks} />} />
                {arc.map((el, i) => {
                    return (<Route path={el.aroute} element={<Archive navParks={navParks} id={el.id} slug={el.aslug} />} key={i} />)
                })}
                <Route path="*" element={<NotFound navParks={navParks} />} />
            </Routes>
        </BrowserRouter>
    )
}